import { render, staticRenderFns } from "./unit-list.vue?vue&type=template&id=3a770f10&scoped=true"
import script from "./unit-list.vue?vue&type=script&lang=js"
export * from "./unit-list.vue?vue&type=script&lang=js"
import style0 from "./unit-list.vue?vue&type=style&index=0&id=3a770f10&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a770f10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a770f10')) {
      api.createRecord('3a770f10', component.options)
    } else {
      api.reload('3a770f10', component.options)
    }
    module.hot.accept("./unit-list.vue?vue&type=template&id=3a770f10&scoped=true", function () {
      api.rerender('3a770f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/units/list/unit-list.vue"
export default component.exports